import React from "react";
import { Button, ButtonProps, Theme } from "@mui/material";
import { SxProps } from "@mui/system";

interface EcnButtonProps extends ButtonProps {
  radius?: string;
}

const EcnButton = ({
  radius,
  className,
  sx,
  children,
  ...rest
}: EcnButtonProps) => {
  const baseStyles: SxProps<Theme> = {
    display: "inline-flex",
    height: "36px",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    background: "#1D2939",
    width: "191px",
    color: "#FFF",
    padding: "8px 14px",
    boxShadow: "0px 1px 2px 0px rgba(10, 13, 18, 0.05)",
    borderRadius: radius,
    "&:hover": {
      backgroundColor: "#000",
    },
    "&.Mui-disabled": {
      backgroundColor: "rgb(111, 111, 111)",
      border: "1px solid rgb(111, 111, 111)",
      color: "#FFF",
    },
  };

  // Combine base styles with sx from props safely
  const mergedSx: SxProps<Theme> = Array.isArray(sx)
    ? [baseStyles, ...sx]
    : sx
    ? [baseStyles, sx]
    : baseStyles;

  return (
    <Button className={className} {...rest} sx={mergedSx}>
      {children}
    </Button>
  );
};

export default EcnButton;
